module.exports = __webpack_public_path__ + "img/sms.b67be2d4.png";